import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllusers, deleteUser } from '../Redux/Actions/AuthActions';
import { Container, Table, Badge, Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ListUser = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllusers());
  }, [dispatch]);

  const allUsers = useSelector((state) => state.AuthReducer.users);
  const currentUser = useSelector((state) => state.AuthReducer.user);

  // Filtrer les utilisateurs (Admin ou userAdmin) et par localisation
  const filteredUsers = allUsers?.filter((user) => {
    const isTargetRole = user.role === 'admin' || user.role === 'useradmin';
    if (!isTargetRole) return false;

    // Si l'utilisateur connecté est un useradmin, il ne voit que ceux de sa localisation
    if (currentUser?.role === 'useradmin') {
      // Comparaison sécurisée avec l'objet ou l'ID de localisation
      const userLocId = user.localisation?._id || user.localisation;
      const currentLocId = currentUser.localisation?._id || currentUser.localisation;
      return userLocId === currentLocId;
    }

    // Les admins globaux (Direction) voient tout

    return true;
  });

  const handleDelete = (id) => {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cet utilisateur ?")) {
      dispatch(deleteUser(id));
    }
  };

  return (
    <Container className="py-5">
      <Card className="shadow-sm border-0">

        <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center py-3">
          <h3 className="mb-0">Gestion des Administrateurs</h3>
          <Badge bg="light" text="dark" className="px-3 py-2">
            {currentUser?.localisation?.name || 'Toutes localisations'}
          </Badge>
        </Card.Header>
        <Card.Body className="p-0">
          <div className="table-responsive">
            <Table hover className="align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th className="ps-4">Utilisateur</th>
                  <th>Email</th>
                  <th>Rôle</th>
                  <th>Localisation</th>
                  <th className="text-center pe-4">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers && filteredUsers.length > 0 ? (
                  filteredUsers.map((el) => (
                    <tr key={el._id}>
                      <td className="ps-4 fw-bold text-dark">{el.name}</td>
                      <td className="text-muted">{el.email}</td>
                      <td>
                        <Badge bg={el.role === 'admin' ? 'danger' : 'info'} pill className="px-3">
                          {el.role === 'admin' ? 'Direction' : 'Administration'}
                        </Badge>
                      </td>
                      <td>
                        <span className="text-secondary small">
                          {el.localisation?.name || '---'}
                        </span>
                      </td>
                      <td className="pe-4">
                        <div className="d-flex justify-content-center gap-2">
                          <Button
                            as={Link}
                            to={`/UpdateUser/${el._id}`}
                            variant="outline-warning"
                            size="sm"
                            className="btn-action"
                          >
                            Modifier
                          </Button>
                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() => handleDelete(el._id)}
                            className="btn-action"
                          >
                            Supprimer
                          </Button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-5 text-muted italic">
                      <div>🔍 Aucun administrateur trouvé.</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ListUser;
